import {Store} from "../models/";
import favouriteStoreIcon from "../../../assets/images/png/favouriteStore.png";
import storeIconSmall from "../../../assets/images/png/store-icon-small.png";
import storeIconBig from "../../../assets/images/png/store-icon-big.png";
import gps from "../../../assets/images/svg/gps-icon.svg";
import {MarkerClusterer, SuperClusterAlgorithm} from "@googlemaps/markerclusterer";
import {createMarkerContent} from "../utils/marker-content";
import {CustomRenderer} from "../utils/renderer";

export class MarkerController {

  // =========================
  // 🔹 MARKER CREATION
  // =========================

  createMarkers(map: google.maps.Map | undefined, stores: Store[], onSelectStore: (store: Store) => void): google.maps.marker.AdvancedMarkerElement[] {
    return stores.map(store => {
      const marker = this.createMarker(map, store);

      marker.addListener('click', () => onSelectStore(store));

      return marker;
    });
  }

  createMarker(map: google.maps.Map | undefined, store: Store): google.maps.marker.AdvancedMarkerElement {
    const title = [store.address_line_1, store.address_line_2, store.address_line_3]
      .filter(Boolean)
      .join(', ');

    const iconClass = store.isFavourite ? favouriteStoreIcon : storeIconSmall;

    let marker = new google.maps.marker.AdvancedMarkerElement({
      position: new google.maps.LatLng(store.lat, store.lng),
      title,
      content: createMarkerContent(iconClass, 20),
      map,
    });

    marker = this.addBounce(marker);

    store.marker = marker;

    return marker;
  }

  createPositionMarker(currentPosition: google.maps.LatLng, map?: google.maps.Map) {
    return new google.maps.marker.AdvancedMarkerElement({
      position: currentPosition,
      title: "Position",
      content: createMarkerContent(gps, 20, 0, true),
      map,
    });
  }

  // =========================
  // 🔹 MARKER INTERACTION STATE
  // =========================

  handleMarkerChanged(selectedStore: Store, currentStore?: Store) {
    if (selectedStore.isFavourite) {
      return;
    }

    if (currentStore?.marker && !currentStore.isFavourite) {
      currentStore.marker.content = createMarkerContent(storeIconSmall, 20);
    }

    if (selectedStore.marker) {
      selectedStore.marker.content = createMarkerContent(storeIconBig, 40);
    }
  }

  resetStore(stores: Store[], id?: string) {
    const store = stores.find(it => it.id === id);

    if (!store?.marker) {
      return;
    }

    store.isFavourite = false;
    store.marker.content = createMarkerContent(storeIconSmall, 20);
  }

  resetIcon(store?: Store) {
    if (!store?.marker) {
      return;
    }

    if (!store.isFavourite) {
      store.marker.content = createMarkerContent(storeIconSmall, 20);
    }
  }

  // =========================
  // 🔹 MARKER CLUSTERING
  // =========================

  createMarkerCluster(markers?: google.maps.marker.AdvancedMarkerElement[], map?: google.maps.Map) {
    return new MarkerClusterer({
      renderer: new CustomRenderer(),
      markers,
      map,
      algorithm: new SuperClusterAlgorithm({
        maxZoom: 16,
        minZoom: 1,
        minPoints: 3,
        radius: 70,
        extent: 300,
        nodeSize: 64,
      }),
    });
  }

  // =========================
  // 🔹 MARKER ANIMATION BEHAVIOUR
  // =========================

  addBounce(marker: google.maps.marker.AdvancedMarkerElement) {
    marker.addListener('click', () => {
      requestAnimationFrame(() => {
        const el = marker.element?.querySelector('.marker-container') as HTMLElement;
        if (!el) {
          return;
        }

        el.classList.add('bounce');
        el.addEventListener('animationend', () => el.classList.remove('bounce'), { once: true });
      });
    });

    return marker;
  }
}